window.bundleDataE = {
"Eagan-boy": {
displayName: "Eagan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Eagan Personalized Coloring Experience",
variantId: "49929630482669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eagan_final_cover.png?v=1777856530",
price: "$14.99",
preorder: true
},
{
title: "Eagan Dragon Holographic Sticker",
variantId: "49933746110701",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eagan_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Eagan Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Easton-boy": {
displayName: "Easton",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Easton Personalized Coloring Experience",
variantId: "49343579848941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Easton_final_cover.png?v=1772388163",
price: "$14.99",
preorder: true
},
{
title: "Easton Dragon Holographic Sticker",
variantId: "49933771931885",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Easton_holographic_sticker.png?v=1779378942",
price: "$4.99",
preorder: false
},
{
title: "Easton Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Eden-girl": {
displayName: "Eden",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Eden Personalized Coloring Experience",
variantId: "49279568281837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eden_final_cover.png?v=1773719956",
price: "$14.99",
preorder: true
},
{
title: "Eden Unicorn Holographic Sticker",
variantId: "49933776519405",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eden_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Eden Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Eduardo-boy": {
displayName: "Eduardo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Eduardo Personalized Coloring Experience",
variantId: "49343580340461",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eduardo_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Eduardo Dragon Holographic Sticker",
variantId: "49933771899117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eduardo_holographic_sticker.png?v=1779378943",
price: "$4.99",
preorder: false
},
{
title: "Eduardo Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Edward-boy": {
displayName: "Edward",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Edward Personalized Coloring Experience",
variantId: "49343580963053",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Edward_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Edward Dragon Holographic Sticker",
variantId: "49933771866349",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Edward_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Edward Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Eleanor-girl": {
displayName: "Eleanor",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Eleanor Personalized Coloring Experience",
variantId: "49479164330221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eleanor_final_cover.png?v=1772930026",
price: "$14.99",
preorder: true
},
{
title: "Eleanor Unicorn Holographic Sticker",
variantId: "49933758824685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eleanor_holographic_sticker.png?v=1779425512",
price: "$4.99",
preorder: false
},
{
title: "Eleanor Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Elena-girl": {
displayName: "Elena",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elena Personalized Coloring Experience",
variantId: "49479232028909",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elenafinalfinalcover.png?v=1773326382",
price: "$14.99",
preorder: true
},
{
title: "Elena Unicorn Holographic Sticker",
variantId: "49933758529773",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elena_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Elena Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Eli-boy": {
displayName: "Eli",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Eli Personalized Coloring Experience",
variantId: "49343581257965",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eli_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Eli Dragon Holographic Sticker",
variantId: "49933771833581",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eli_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Eli Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Eliana-girl": {
displayName: "Eliana",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Eliana Personalized Coloring Experience",
variantId: "49479323058413",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eliana_final_cover.png?v=1772930025",
price: "$14.99",
preorder: true
},
{
title: "Eliana Unicorn Holographic Sticker",
variantId: "49933758267629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eliana_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Eliana Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Elias-boy": {
displayName: "Elias",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elias Personalized Coloring Experience",
variantId: "49343583912173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elias_final_cover.png?v=1771691709",
price: "$14.99",
preorder: true
},
{
title: "Elias Dragon Holographic Sticker",
variantId: "49933771800813",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elias_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Elias Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Elijah-boy": {
displayName: "Elijah",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elijah Personalized Coloring Experience",
variantId: "49343585091821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elijah_final_cover.png?v=1772388163",
price: "$14.99",
preorder: true
},
{
title: "Elijah Dragon Holographic Sticker",
variantId: "49933771768045",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elijah_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Elijah Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Elio-boy": {
displayName: "Elio",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elio Personalized Coloring Experience",
variantId: "49709408485613",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elio_final_cover.png?v=1774104746",
price: "$14.99",
preorder: true
},
{
title: "Elio Dragon Holographic Sticker",
variantId: "49933753712877",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elio_holographic_sticker.png?v=1779648202",
price: "$4.99",
preorder: false
},
{
title: "Elio Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Elise-girl": {
displayName: "Elise",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elise Personalized Coloring Experience",
variantId: "49801338126573",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elise_final_cover.png?v=1775415417",
price: "$14.99",
preorder: true
},
{
title: "Elise Unicorn Holographic Sticker",
variantId: "49933746176237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elise_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Elise Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Elizabeth-girl": {
displayName: "Elizabeth",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elizabeth Personalized Coloring Experience",
variantId: "49279568380141",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elizabeth_final_cover.png?v=1773719956",
price: "$14.99",
preorder: true
},
{
title: "Elizabeth Unicorn Holographic Sticker",
variantId: "49933776453869",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elizabeth_holographic_sticker.png?v=1779425515",
price: "$4.99",
preorder: false
},
{
title: "Elizabeth Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ella-girl": {
displayName: "Ella",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ella Personalized Coloring Experience",
variantId: "49479272235245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ella_final_cover.png?v=1772930029",
price: "$14.99",
preorder: true
},
{
title: "Ella Unicorn Holographic Sticker",
variantId: "49933758398701",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ella_holographic_sticker.png?v=1779425517",
price: "$4.99",
preorder: false
},
{
title: "Ella Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ellie-girl": {
displayName: "Ellie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ellie Personalized Coloring Experience",
variantId: "49279568445677",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ellie_final_cover.png?v=1772908493",
price: "$14.99",
preorder: true
},
{
title: "Ellie Unicorn Holographic Sticker",
variantId: "49933776421101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ellie_holographic_sticker.png?v=1779425514",
price: "$4.99",
preorder: false
},
{
title: "Ellie Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Elliot-boy": {
displayName: "Elliot",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elliot Personalized Coloring Experience",
variantId: "49343589220589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elliot_final_cover.png?v=1771691710",
price: "$14.99",
preorder: true
},
{
title: "Elliot Dragon Holographic Sticker",
variantId: "49933771735277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elliot_holographic_sticker.png?v=1779648205",
price: "$4.99",
preorder: false
},
{
title: "Elliot Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ellis-boy": {
displayName: "Ellis",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ellis Personalized Coloring Experience",
variantId: "49279568609517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ellis_final_cover.png?v=1771691711",
price: "$14.99",
preorder: true
},
{
title: "Ellis Dragon Holographic Sticker",
variantId: "49933776388333",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ellis_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Ellis Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ellison-girl": {
displayName: "Ellison",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ellison Personalized Coloring Experience",
variantId: "49983119917293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ellison_final_cover.png?v=1779029297",
price: "$14.99",
preorder: true
},
{
title: "Ellison Unicorn Holographic Sticker",
variantId: "49983092392173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ellisonforwebsite.png?v=1779025165",
price: "$4.99",
preorder: false
},
{
title: "Ellison Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Elodie-girl": {
displayName: "Elodie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elodie Personalized Coloring Experience",
variantId: "49274317078765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elodie_final_cover.png?v=1773719957",
price: "$14.99",
preorder: true
},
{
title: "Elodie Unicorn Holographic Sticker",
variantId: "49933780844781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elodie_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Elodie Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Eloise-girl": {
displayName: "Eloise",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Eloise Personalized Coloring Experience",
variantId: "49299057443053",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eloise_final_cover.png?v=1773766537",
price: "$14.99",
preorder: true
},
{
title: "Eloise Unicorn Holographic Sticker",
variantId: "49933772783853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eloise_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Eloise Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Elowen-girl": {
displayName: "Elowen",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elowen Personalized Coloring Experience",
variantId: "49479337672941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elowen_final_cover.png?v=1772930029",
price: "$14.99",
preorder: true
},
{
title: "Elowen Unicorn Holographic Sticker",
variantId: "49933758234861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elowen_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Elowen Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Elsa-girl": {
displayName: "Elsa",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elsa Personalized Coloring Experience",
variantId: "49479264305389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elsa_final_cover.png?v=1772930029",
price: "$14.99",
preorder: true
},
{
title: "Elsa Unicorn Holographic Sticker",
variantId: "49933758431469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elsa_holographic_sticker.png?v=1779425513",
price: "$4.99",
preorder: false
},
{
title: "Elsa Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Elsie-girl": {
displayName: "Elsie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elsie Personalized Coloring Experience",
variantId: "49479282163949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elsie_final_final_cover.png?v=1773327516",
price: "$14.99",
preorder: true
},
{
title: "Elsie Unicorn Holographic Sticker",
variantId: "49933758365933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elsie_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Elsie Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Emerson-girl": {
displayName: "Emerson",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Emerson Personalized Coloring Experience",
variantId: "49279568642285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emerson_final_cover.png?v=1773719956",
price: "$14.99",
preorder: true
},
{
title: "Emerson Unicorn Holographic Sticker",
variantId: "49933776355565",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emerson_holographic_sticker.png?v=1779425513",
price: "$4.99",
preorder: false
},
{
title: "Emerson Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Emersyn-girl": {
displayName: "Emersyn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Emersyn Personalized Coloring Experience",
variantId: "49801315287277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emersyn_final_cover.png?v=1775415295",
price: "$14.99",
preorder: true
},
{
title: "Emersyn Unicorn Holographic Sticker",
variantId: "49933752762605",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emersyn_holographic_sticker.png?v=1779425513",
price: "$4.99",
preorder: false
},
{
title: "Emersyn Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Emery-girl": {
displayName: "Emery",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Emery Personalized Coloring Experience",
variantId: "49274291028205",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emery_final_cover.png?v=1773719956",
price: "$14.99",
preorder: true
},
{
title: "Emery Unicorn Holographic Sticker",
variantId: "49933780943085",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emery_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Emery Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Emilia-girl": {
displayName: "Emilia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Emilia Personalized Coloring Experience",
variantId: "49479182385389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emilia_final_cover.png?v=1772930029",
price: "$14.99",
preorder: true
},
{
title: "Emilia Unicorn Holographic Sticker",
variantId: "49933758791917",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emilia_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Emilia Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Emiliano-boy": {
displayName: "Emiliano",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Emiliano Personalized Coloring Experience",
variantId: "49343590957293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emiliano_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Emiliano Dragon Holographic Sticker",
variantId: "49933771702509",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emiliano_holographic_sticker.png?v=1779648205",
price: "$4.99",
preorder: false
},
{
title: "Emiliano Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Emilio-boy": {
displayName: "Emilio",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Emilio Personalized Coloring Experience",
variantId: "49343591252205",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emilio_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Emilio Dragon Holographic Sticker",
variantId: "49933771669741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emilio_holographic_sticker.png?v=1779648210",
price: "$4.99",
preorder: false
},
{
title: "Emilio Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Emily-girl": {
displayName: "Emily",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Emily Personalized Coloring Experience",
variantId: "49279568773357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emilyfinalcover.png?v=1773865750",
price: "$14.99",
preorder: true
},
{
title: "Emily Unicorn Holographic Sticker",
variantId: "49933776126189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emily_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Emily Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Emma-girl": {
displayName: "Emma",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Emma Personalized Coloring Experience",
variantId: "49479240122605",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emma_final_cover.png?v=1772930029",
price: "$14.99",
preorder: true
},
{
title: "Emma Unicorn Holographic Sticker",
variantId: "49933758497005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emma_holographic_sticker.png?v=1779425512",
price: "$4.99",
preorder: false
},
{
title: "Emma Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Emmanuel-boy": {
displayName: "Emmanuel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Emmanuel Personalized Coloring Experience",
variantId: "49343595839725",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emmanuel_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Emmanuel Dragon Holographic Sticker",
variantId: "49933771636973",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emmanuel_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Emmanuel Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Emmett-boy": {
displayName: "Emmett",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Emmett Personalized Coloring Experience",
variantId: "49472179667181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emmett_final_cover.png?v=1772930020",
price: "$14.99",
preorder: true
},
{
title: "Emmett Dragon Holographic Sticker",
variantId: "49933759119597",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emmett_holographic_sticker.png?v=1779648211",
price: "$4.99",
preorder: false
},
{
title: "Emmett Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Enzo-boy": {
displayName: "Enzo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Enzo Personalized Coloring Experience",
variantId: "49343604785389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Enzo_final_cover.png?v=1772469697",
price: "$14.99",
preorder: true
},
{
title: "Enzo Dragon Holographic Sticker",
variantId: "49933771604205",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Enzo_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Enzo Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Eric-boy": {
displayName: "Eric",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Eric Personalized Coloring Experience",
variantId: "49343610847469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eric_final_cover.png?v=1772469698",
price: "$14.99",
preorder: true
},
{
title: "Eric Dragon Holographic Sticker",
variantId: "49933771571437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eric_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Eric Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Erick-boy": {
displayName: "Erick",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Erick Personalized Coloring Experience",
variantId: "49343612715245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Erick_final_cover.png?v=1772469696",
price: "$14.99",
preorder: true
},
{
title: "Erick Dragon Holographic Sticker",
variantId: "49933771538669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Erick_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Erick Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Erin-girl": {
displayName: "Erin",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Erin Personalized Coloring Experience",
variantId: "49508253597933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Erin_final_cover.png?v=1773105079",
price: "$14.99",
preorder: true
},
{
title: "Erin Unicorn Holographic Sticker",
variantId: "49933758202093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Erin_holographic_sticker.png?v=1779425515",
price: "$4.99",
preorder: false
},
{
title: "Erin Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Esme-girl": {
displayName: "Esme",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Esme Personalized Coloring Experience",
variantId: "49274572931309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Esme_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Esme Unicorn Holographic Sticker",
variantId: "49933780648173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Esme_holographic_sticker.png?v=1779425515",
price: "$4.99",
preorder: false
},
{
title: "Esme Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Estelle-girl": {
displayName: "Estelle",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Estelle Personalized Coloring Experience",
variantId: "49274659012845",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Estelle_final_cover.png?v=1773766537",
price: "$14.99",
preorder: true
},
{
title: "Estelle Unicorn Holographic Sticker",
variantId: "49933780582637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Estelle_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Estelle Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Esther-girl": {
displayName: "Esther",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Esther Personalized Coloring Experience",
variantId: "49339342553325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Esther_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Esther Unicorn Holographic Sticker",
variantId: "49933772390637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Esther_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Esther Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ethan-boy": {
displayName: "Ethan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ethan Personalized Coloring Experience",
variantId: "49279568838893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ethan_final_cover.png?v=1772469698",
price: "$14.99",
preorder: true
},
{
title: "Ethan Dragon Holographic Sticker",
variantId: "49933776060653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ethan_holographic_sticker.png?v=1779648211",
price: "$4.99",
preorder: false
},
{
title: "Ethan Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Eva-girl": {
displayName: "Eva",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Eva Personalized Coloring Experience",
variantId: "49508304322797",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eva_final_cover.png?v=1773105079",
price: "$14.99",
preorder: true
},
{
title: "Eva Unicorn Holographic Sticker",
variantId: "49933758071021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eva_holographic_sticker.png?v=1779425517",
price: "$4.99",
preorder: false
},
{
title: "Eva Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Evan-boy": {
displayName: "Evan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Evan Personalized Coloring Experience",
variantId: "49343615107309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Evan_final_cover.png?v=1772469698",
price: "$14.99",
preorder: true
},
{
title: "Evan Dragon Holographic Sticker",
variantId: "49933771505901",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Evan_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Evan Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Evelyn-girl": {
displayName: "Evelyn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Evelyn Personalized Coloring Experience",
variantId: "49508290822381",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Evelyn_final_cover.png?v=1773105079",
price: "$14.99",
preorder: true
},
{
title: "Evelyn Unicorn Holographic Sticker",
variantId: "49933758169325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Evelyn_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Evelyn Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Everett-boy": {
displayName: "Everett",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Everett Personalized Coloring Experience",
variantId: "49279568937197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Everett_final_cover.png?v=1772469697",
price: "$14.99",
preorder: true
},
{
title: "Everett Dragon Holographic Sticker",
variantId: "49933775896813",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Everett_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Everett Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Everly-girl": {
displayName: "Everly",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Everly Personalized Coloring Experience",
variantId: "49508360519917",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Everly_final_cover.png?v=1773105079",
price: "$14.99",
preorder: true
},
{
title: "Everly Unicorn Holographic Sticker",
variantId: "49933757841645",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Everly_holographic_sticker.png?v=1779425515",
price: "$4.99",
preorder: false
},
{
title: "Everly Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Evie-girl": {
displayName: "Evie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Evie Personalized Coloring Experience",
variantId: "49774110671085",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Evie_final_cover.png?v=1775415295",
price: "$14.99",
preorder: true
},
{
title: "Evie Unicorn Holographic Sticker",
variantId: "49933752860909",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Evie_holographic_sticker.png?v=1779425512",
price: "$4.99",
preorder: false
},
{
title: "Evie Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ezekiel-boy": {
displayName: "Ezekiel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ezekiel Personalized Coloring Experience",
variantId: "49343616483565",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ezekiel_final_cover.png?v=1772469698",
price: "$14.99",
preorder: true
},
{
title: "Ezekiel Dragon Holographic Sticker",
variantId: "49933771473133",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ezekiel_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Ezekiel Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ezra-boy": {
displayName: "Ezra",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ezra Personalized Coloring Experience",
variantId: "49441987592429",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ezra_final_cover.png?v=1772582315",
price: "$14.99",
preorder: true
},
{
title: "Ezra Dragon Holographic Sticker",
variantId: "49933759611117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ezra_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Ezra Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Eliza-girl": {
displayName: "Eliza",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Eliza Personalized Coloring Experience",
variantId: "50056818491629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eliza_final_cover.png?v=1780209145",
price: "$14.99",
preorder: true
},
{
title: "Eliza Unicorn Holographic Sticker",
variantId: "50056844738797",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Eliza_holographic_sticker.png?v=1780206654",
price: "$4.99",
preorder: false
},
{
title: "Eliza Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Elliana-girl": {
displayName: "Elliana",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elliana Personalized Coloring Experience",
variantId: "50078228611309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elliana_final_cover.png?v=1780809444",
price: "$14.99",
preorder: true
},
{
title: "Elliana Unicorn Holographic Sticker",
variantId: "50077629677805",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elliana_sticker_website.png?v=1780804206",
price: "$4.99",
preorder: false
},
{
title: "Elliana Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Everleigh-girl": {
displayName: "Everleigh",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Everleigh Personalized Coloring Experience",
variantId: "50078342185197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Everleigh_final_cover.png?v=1780809444",
price: "$14.99",
preorder: true
},
{
title: "Everleigh Unicorn Holographic Sticker",
variantId: "50077639999725",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Everleigh_sticker_website.png?v=1780804206",
price: "$4.99",
preorder: false
},
{
title: "Everleigh Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Elliott-boy": {
displayName: "Elliott",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elliott Personalized Coloring Experience",
variantId: "50127706489069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elliottfinalcover.png?v=1781988163",
price: "$14.99",
preorder: true
},
{
title: "Elliott Dragon Holographic Sticker",
variantId: "50127678210285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elliottwebsitesticker.png?v=1781987287",
price: "$4.99",
preorder: false
},
{
title: "Elliott Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
 "Ember-girl": {
displayName: "Ember",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ember Personalized Coloring Experience",
variantId: "50245857313005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ember_final_cover.png?v=1783566389",
price: "$14.99",
preorder: true
},
{
title: "Ember Unicorn Holographic Sticker",
variantId: "50259990413549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ember_holographic_sticker.png?v=1783785471",
price: "$4.99",
preorder: false
},
{
title: "Ember Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Elian-boy": {
displayName: "Elian",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Elian Personalized Coloring Experience",
variantId: "50449695637741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elian_final_cover.png?v=1786244941",
price: "$14.99",
preorder: true
},
{
title: "Elian Dragon Holographic Sticker",
variantId: "50449593401581",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Elian_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Elian Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Emerson-boy": {
displayName: "Emerson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Emerson Personalized Coloring Experience",
variantId: "50457715835117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emerson_final_cover_024fb587-421e-49a2-8f1e-0fb472e08a75.png?v=1786406747",
price: "$14.99",
preorder: true
},
{
title: "Emerson Dragon Holographic Sticker",
variantId: "50457558155501",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Emerson_boy_holographic_sticker.png?v=1786406786",
price: "$4.99",
preorder: false
},
{
title: "Emerson Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Evangeline-girl": {
displayName: "Evangeline",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Evangeline Personalized Coloring Experience",
variantId: "50519271276781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Evangeline_final_cover.png?v=1786941539",
price: "$14.99",
preorder: true
},
{
title: "Evangeline Unicorn Holographic Sticker",
variantId: "50497544618221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Evangeline_holographic_sticker.png?v=1787505458",
price: "$4.99",
preorder: false
},
{
title: "Evangeline Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 








};